import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getVoteNum, vote } from '@Container/common/client/services/api';
import errorBoundary from '@ifeng/errorBoundary';

class Vote extends React.PureComponent {
    static propTypes = {
        voteId: PropTypes.string,
    };

    state = {
        isVoted: false,
        voteNum: 0,
    };

    async componentDidMount() {
        try {
            const { voteId } = this.props;

            const data = await getVoteNum(`${voteId}ding`);

            this.setState({ voteNum: data.browse[`${voteId}ding`] });
        } catch (e) {
            console.error(e);
        }
    }

    vote = async () => {
        try {
            const { isVoted } = this.state;

            if (isVoted) {
                return;
            }

            const { voteId } = this.props;

            const data = await vote(`${voteId}ding`);

            this.setState({
                isVoted: !isVoted,
                voteNum: data,
            });
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { isVoted, voteNum } = this.state;

        return (
            <div className={isVoted ? styles.voted : styles.vote} onClick={this.vote}>
                推荐<span>{voteNum}</span>
            </div>
        );
    }
}

export default errorBoundary(Vote);
